import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { SubHeading } from '../typography';

export const Wrapper = styled.div`
  margin: 0 auto 60px;
  max-width: 1260px;
  width: 100%;
  padding: 0 30px;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
  }
`;

export const Container = styled.div`
  display: flex;

  @media (${laptopMediumMax}) {
    flex-direction: column;

    &:first-child {
      margin-top: 40px;
    }

    ${SubHeading} {
      display: none;
    }
  }
`;

export const LoadingBox = styled.div<{ bg?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  ${({ bg }) => (bg ? `background: ${bg};` : '')}
`;

export const ChartContainer = styled.div`
  padding-right: 30px;
  padding-bottom: 30px;
`;

export const ExtraContainer = styled.div`
  border-left: 1px solid ${(props) => props.theme.keyline};
  padding-left: 30px;
  padding-bottom: 30px;

  @media (${laptopMediumMax}) {
    border-left: none;
    padding-left: 0;
  }
`;

export const StyleStatsWrapper = styled.div`
  @media (${laptopMediumMax}) {
    display: flex;
    flex-wrap: wrap;
    max-width: 800px;
  }
`;

export const StyleStats = styled.div`
  display: flex;
  margin-bottom: 30px;
  margin-right: 30px;
  align-items: center;

  svg {
    width: 80px;
    height: 60px;
    margin-right: 15px;
  }
`;
